import React from "react";
import { PRIMARY_COLOR } from "../Services/Colors";

const SubmitButton = ({ onClick, title = "Submit", disabled, isFormValid = false, loading, width, style, className }) => {

    return (
        <button
            disabled={disabled}
            type="button"
            style={{
                backgroundColor: isFormValid
                    ? "#7ea1b8cc"
                    : PRIMARY_COLOR,
                cursor: disabled ? "not-allowed" : "pointer",
                // opacity: disabled ? 0.6 : 1,
                minWidth: width ? '41.66666667%' : '100%',
                color:'#fff',
                ...style
            }}
            className={`add-button f3 fs-xl-14 fs-xxl-18 ${className || ""}`}
            onClick={onClick}
        >
            {loading ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                    ></span>
                </>
            ) : (
                title
            )}
        </button>
    )
}
export default SubmitButton;
